module.exports = __webpack_public_path__ + "img/album02_01.de9749bf.jpg";